import { CandidateFiltersRequestDto, Api } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

class TalentApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }
}

export const LegacyTalentApi = new TalentApiClass();

/**
 * This is displayed to user so needs to be talent, not candidate
 */
const api = new LegacyApiHelper('talent');

export const getTalents = async (filterMeta = { page: 1 }) => {
  const requestBody = new CandidateFiltersRequestDto(filterMeta);
  const { data, meta } = await api.POST(
    `${EnvUtil.apiEnvoyUrl}/candidates/search`,
    requestBody.export()
  );
  return { data, meta };
};

export const getTalent = async (candidateID: Candidate['id']) => {
  const response = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/candidates/${candidateID}`
  );
  return { data: response.data };
};

export const downloadTalentList = async (body: {
  request: Record<string, unknown>;
}) => {
  const response = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/downloads/candidates`,
    body,
    true
  );
  return response;
};
